<template>
  <table-tr
    :row="row"
    :row-prop="table.rowProps[row.id]"
    :hover="!table.disabledHover"
    :row-class-name="table.rowClassName"
    @click="table.onClickRow(row)"
    @dblclick="table.onDblClickRow(row)"
  >
    <table-td
      v-for="column in columns"
      :key="column.key"
      :row="row"
      :column="column"
    >
      <table-cell
        :row="row"
        :column="column"
        :row-prop="table.rowProps[row.id]"
        :row-index="rowIndex" />
    </table-td>
  </table-tr>
</template>
<script>
import TableTr from './table-tr.vue';
import TableTd from './table-td.vue';
import TableCell from './table-cell.vue';

export default {
  inject: ['table'],
  components: {
    TableTr, TableTd, TableCell,
  },
  props: {
    row: { type: Object, required: true },
    columns: { type: Array, required: true },
    rowIndex: { type: Number, required: true },
  },
};
</script>
